import { ImportResult } from "../types";
import { EnvVarInput } from "../../../schema/types/workload/input";
import { EnvVar } from "../../../schema/types/env";
import { envToInput } from "../../../pages/workload/draft/utils/envVar";
import { v4 as uuidv4 } from "uuid";

/**
 * Env var transformer for GVC and Workload environment variables.
 * Handles special prefixes: cpln://secret/, k8s://secret/, cpln://reference/
 */
export function envVarTransformer(
  parsed: Record<string, unknown>,
  existing: EnvVarInput[]
): ImportResult<EnvVarInput[]> {
  const overriddenKeys: string[] = [];

  // Convert parsed record to EnvVar[] format
  const rawVars: EnvVar[] = Object.entries(parsed).map(([name, value]) => ({
    name,
    value: String(value ?? ""),
  }));

  // Use existing envToInput to handle special prefixes (cpln://secret/, k8s://secret/, cpln://reference/)
  const envVarMeta = envToInput(rawVars);

  // Clone existing array
  const result: EnvVarInput[] = existing.map((item) => ({ ...item }));

  for (const envVar of envVarMeta) {
    const existingIndex = result.findIndex((v) => v.name === envVar.name);

    if (existingIndex !== -1) {
      // Override existing
      overriddenKeys.push(envVar.name);
      result[existingIndex] = {
        ...result[existingIndex],
        prefix: envVar.prefix,
        text: envVar.text,
        cplnSecret: envVar.cplnSecret,
        k8sSecret: envVar.k8sSecret,
        reference: envVar.reference,
        suffix: envVar.suffix,
      };
    } else {
      // Add new with generated ID
      result.push({
        id: uuidv4(),
        name: envVar.name,
        prefix: envVar.prefix,
        text: envVar.text,
        cplnSecret: envVar.cplnSecret,
        k8sSecret: envVar.k8sSecret,
        reference: envVar.reference,
        suffix: envVar.suffix,
      });
    }
  }

  return {
    success: true,
    data: result,
    overriddenKeys,
  };
}
